export const NGT_PARTNER_ID = 85;

